import { AxiosInstance } from "axios";
import { Publisher } from "../../../domain/Publisher";

// Admin management of developer-portal (publisher) accounts. Hits the admin-guarded endpoints under
// /publisher/admin, which are separate from the consumer /user and legacy /developer resources.
export class PublisherService {

  constructor(
    private axios: AxiosInstance,
  ) { }

  fetchPublishers() {
    return this.axios.get<Publisher[]>('/publisher/admin/accounts').then(res => res.data);
  }

  deletePublisher(id: number) {
    return this.axios.delete(`/publisher/admin/accounts/${id}`);
  }

}
